// extracted by mini-css-extract-plugin
module.exports = {"body":"BuyCreditsModal_body__BSQxO","pack":"BuyCreditsModal_pack___frQE","content":"BuyCreditsModal_content__trfAa","row":"BuyCreditsModal_row__ySeaX"};